import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function SiteAuditIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame {...props}>
      <path
        d="M24 16.5V22M9 30v-8h30v8"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 33v6c0 1.656-1.344 3-3 3H7c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h4c1.656 0 3 1.344 3 3ZM29 33v6c0 1.656-1.344 3-3 3h-4c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h4c1.656 0 3 1.344 3 3ZM44 33v6c0 1.656-1.344 3-3 3h-4c-1.656 0-3-1.344-3-3v-6c0-1.656 1.344-3 3-3h4c1.656 0 3 1.344 3 3Z"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="2"
      />
      <path
        d="m31.5 10-3.75 6.5h-7.5L16.5 10l3.75-6.5h7.5z"
        fill="none"
        stroke={toolIconSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
